import toast from "react-hot-toast";
import * as api from "../Api/index";
import io from "socket.io-client";

const socket = io();
export const pendingClaims = () => async (dispatch) => {
  try {
    const { data } = await api.getPendingClaim();
    dispatch({ type: "GET_ALL_PENDING_CLAIMS", payload: data });
  } catch (error) {}
};

export const approveClaimHeadOffice = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Submitting...");
    await api.approveHeadOfficeClaim(id, postData);
    dispatch({ type: "HEAD_OFFICE_APPROVING_CLAIM", payload: id });
    toast.remove(updatingId);
    toast.success("successfully submitted");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};
